import { ApiUtil } from 'lecom-api';

import { FormStoreValuesSynchronizer } from '../handlers/helpers';

const resetState = {
	formAction: 'create',
	selectedRowId: null,
	selectedDataRow: null,
};

export default {
	execute,
};

function execute(gridFormName, initialValues) {
	return new Promise(resolve => {
		const initialValuesToReset = buildInitialValuesToReset(gridFormName, initialValues);
		const promise = FormStoreValuesSynchronizer.sync(gridFormName, initialValuesToReset);

		promise.then(() => resolve(resetState));
	});
}

const buildInitialValuesToReset = (gridFormName, initialValues) => {
	const gridFormFieldAPI = ApiUtil.getFieldAPI(gridFormName);

	return gridFormFieldAPI.fields().reduce((acc, field) => {
		return Object.assign(acc, buildInitialValueToReset(field, initialValues));
	}, {});
};

const buildInitialValueToReset = (field, initialValues) => {
	const value = (initialValues ? (initialValues[field.id] || '') : '');

	return {
		[field.id]: value
	}
};
